import React, { Component, useState, useEffect, useMemo, useRef } from 'react'
import { Grid, FormControl } from '@mui/material'
import { JsonFormsDispatch } from '@jsonforms/react';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { JsonForms } from '@jsonforms/react';
import { useJsonForms } from '@jsonforms/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import FileWidget from './FileWidget'
import { useNavigate } from 'react-router-dom'
import { setPrevStage, clearJobData, setJobData } from '../../../store/job/jobSlice'
import { useDispatch, useSelector } from 'react-redux'
import { rankWith, isControl, uiTypeIs, optionIs, and } from '@jsonforms/core';
import { withJsonFormsLayoutProps, withJsonFormsControlProps } from '@jsonforms/react';
import { setCompany, setProcessTab, get_company_process, setStageTab } from '../../../store/user/userSlice';
import { get_customer_list } from '../../../store/customer/customerSlice';
import { get_company_users } from '../../../store/account/accountSlice';
import { api_get_job_count_by_user } from '../../../store/job/jobApi';
import { isAuth } from '../../../helpers/cookies';
import { formatDateTime, formatDate } from '../../../helpers/cookies';
import { grey } from "@mui/material/colors";
import AddToPhotosOutlinedIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import { SvgIcon } from "@mui/material";
import SendProofModal from './SendProofModal';
import SendIcon from '@mui/icons-material/Send';
import Tooltip from "@mui/material/Tooltip";
import EditNoteIcon from '@mui/icons-material/EditNote';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import PdfThumbnail from './PdfThumbnail';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Chip } from "@mui/material";

const EditSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </g>
  </SvgIcon>
);

const theme = createTheme({
  components: {
    MuiInputLabel: {
      defaultProps: {
        shrink: true
      },
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
          backgroundColor: 'white', // Matches the container background
          padding: '0 4px',
        }
      }
    },
    MuiInputBase: {
      defaultProps: { size: 'small' },
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#000000",
            WebkitTextFillColor: "#000000 !important",
            opacity: 1
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BDBDBD"
          }
        },
        input: {
          "&.Mui-disabled": {
            color: "#000000 !important",
            WebkitTextFillColor: "#000000 !important",
            opacity: 1
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '17px', // Uniform spacing
          width: '100%'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '20px'
        }
      }
    }

  }
});





const JobDetail = ({
  mode,
  job_form,
  job_data,
  job_id,
  job_detail,
  proof_log_data,
  handleZipDownload
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { company_process, company_process_stage, selected_process_tab, selected_company, company_users_list } = useSelector(state => state.user);
  const { sidebar_menus } = useSelector(state => state.job);
  const { customer_list } = useSelector(state => state.customer);
  const { company_users } = useSelector(state => state.account);

  const [formData, setFormData] = useState(null);
  const [openSendProof, setOpenSendProof] = useState(false);
  const [listsReady, setListsReady] = useState(false);
  const [userJobCounts, setUserJobCounts] = useState({});
  const fetchedCompanyListsRef = useRef(null);

  // Fetch job counts for artists/users once per distinct user list
  useEffect(() => {
    const rawUsers = (company_users && company_users.length > 0) ? company_users : (company_users_list || []);
    if (!rawUsers || rawUsers.length === 0) return;

    const artistUsers = rawUsers.filter(
      (u) => u && (u.role === 'ADDNECTAR_ARTIST' || u.role === 6)
    );
    if (artistUsers.length === 0) return;

    Promise.all(
      artistUsers.map(async (u) => {
        try {
          const res = await api_get_job_count_by_user(u.id);
          const countVal = typeof res?.data === 'number' ? res.data : (typeof res === 'number' ? res : (res?.data?.count ?? 0));
          return { id: u.id, count: countVal };
        } catch (e) {
          console.error("Error fetching job count for user", u.id, e);
          return { id: u.id, count: 0 };
        }
      })
    ).then((results) => {
      const countsMap = {};
      results.forEach(({ id, count }) => {
        countsMap[id] = count;
      });
      setUserJobCounts(countsMap);
    });
  }, [company_users, company_users_list]);

  useEffect(() => {
    if (!selected_company || fetchedCompanyListsRef.current === selected_company) {
      if (!listsReady) setListsReady(true);
      return;
    }
    fetchedCompanyListsRef.current = selected_company;
    const fetchLists = async () => {
      try {
        await Promise.allSettled([
          dispatch(get_customer_list({ page: 1, limit: 1000 })),
          dispatch(get_company_users({ company_id: selected_company, page: 1, limit: 1000 }))
        ]);
      } catch (error) {
        console.error("Error fetching form lists:", error);
      } finally {
        setListsReady(true);
      }
    };
    fetchLists();
  }, [dispatch, selected_company, listsReady]);

  useEffect(() => {
    if (mode !== 'create' && job_detail) {
      const currentDetailId = job_detail.id || job_detail.job_id;
      if (job_id && currentDetailId && String(currentDetailId) !== String(job_id)) {
        return;
      }
      const jd = job_detail.job_data || {};

      let assignedToVal = [];
      const hasExplicitAssigned = jd && jd.hasOwnProperty('assigned_to') && jd.assigned_to !== undefined && jd.assigned_to !== null;
      const rawAssigned = hasExplicitAssigned ? jd.assigned_to : job_detail.assigned_to;

      if (Array.isArray(rawAssigned)) {
        assignedToVal = rawAssigned.map(x => Number(x)).filter(x => !isNaN(x) && x > 0);
      } else if (typeof rawAssigned === 'string') {
        const trimmed = rawAssigned.trim();
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              assignedToVal = parsed.map(x => Number(x)).filter(x => !isNaN(x) && x > 0);
            }
          } catch (e) { }
        } else if (trimmed.includes(',')) {
          assignedToVal = trimmed.split(',').map(x => Number(x.trim())).filter(x => !isNaN(x) && x > 0);
        } else if (!isNaN(Number(trimmed)) && Number(trimmed) > 0) {
          assignedToVal = [Number(trimmed)];
        }
      } else if (typeof rawAssigned === 'number' && rawAssigned > 0) {
        assignedToVal = [rawAssigned];
      }

      if (!hasExplicitAssigned && assignedToVal.length === 0 && job_detail.assigned_to) {
        assignedToVal = [job_detail.assigned_to];
      }

      setFormData({
        ...jd,
        assigned_to: assignedToVal,
        stage: job_detail.stage?.name,
        created_date: formatDateTime(job_detail.created_date),
        submitted_date: formatDate(jd?.submitted_date || job_detail.submitted_date || jd?.submitted_date_time || jd?.job_time || job_detail.created_date),
        completed_file_date:
          jd?.completed_file_date ||
          jd?.job_items?.[0]?.completed_file_date ||
          null
      });

      dispatch(setPrevStage(job_detail.stage?.name));
      dispatch(setStageTab(job_detail.stage?.id));
    } else {
      setFormData(job_data || {});
    }
  }, [mode, job_detail, job_data, dispatch]);

  const fileInputTester = rankWith(
    5,
    and(uiTypeIs('Control'), optionIs('renderer', 'fileInputTester'))
  );

  const fileInputWithBrandTester = rankWith(
    5,
    and(uiTypeIs('Control'), optionIs('renderer', 'FileInputWithBrandOption'))
  );

  const SubmittedDateLabelRenderer = ({ uischema, data, label }) => {
    const path = uischema?.scope ? uischema.scope.replace('#/properties/', '').split('/').pop() : 'submitted_date';
    const displayLabel = label || uischema?.text || uischema?.label || "Submitted Date";
    
    let rawValue = data;
    if (typeof data === 'object' && data !== null) {
      rawValue = data[path] || data['submitted_date'] || data['submitted_time'] || data['created_date'];
    }

    return (
      <TextField
        label={displayLabel}
        value={rawValue ? formatDate(rawValue) : ''}
        fullWidth
        variant="outlined"
        size="small"
        InputProps={{
          readOnly: true,
          sx: { color: grey[700] },
          label: displayLabel
        }}
        sx={{ mb: 2.5 }}
      />
    );
  };

  const CompletedDateLabelRenderer = ({ uischema, data, label }) => {
    const path = uischema?.scope ? uischema.scope.replace('#/properties/', '').split('/').pop() : 'completed_file_date';
    const displayLabel = label || uischema?.text || uischema?.label || "Completed Date";

    let rawValue = data;
    if (typeof data === 'object' && data !== null) {
      rawValue = data[path] || data['completed_file_date'] || data['completed_date'];
    }

    return (
      <TextField
        label={displayLabel}
        value={rawValue ? formatDateTime(rawValue) : ''}
        fullWidth
        variant="outlined"
        size="small"
        InputProps={{
          readOnly: true,
          sx: { color: grey[700] },
          label: displayLabel
        }}
        sx={{ mb: 2.5 }}
      />
    );
  };

  /* ===== READ-ONLY RENDERER FOR ASSIGN USERS IN JOB DETAIL ===== */
  const AssignUsersRenderer = ({ data, schema, uischema, label }) => {
    const options = useMemo(() => {
      return schema?.oneOf || schema?.items?.oneOf || [];
    }, [schema]);

    const selectedValues = useMemo(() => {
      if (data === null || data === undefined || data === "") return [];
      if (Array.isArray(data)) return data;
      return [data];
    }, [data]);

    const selectedOptions = useMemo(() => {
      return selectedValues
        .map(val => options.find(opt => opt.const === val) || { const: val, title: `User ${val}` });
    }, [selectedValues, options]);

    const displayLabel = label || "Assign Users";

    return (
      <Box sx={{ mb: 2.5, width: '100%' }}>
        <TextField
          label={displayLabel}
          fullWidth
          variant="outlined"
          size="small"
          InputProps={{
            readOnly: true,
            sx: {
              color: grey[700],
              minHeight: '40px',
              py: selectedOptions.length > 0 ? 0.75 : undefined
            },
            label: displayLabel,
            startAdornment: selectedOptions.length > 0 ? (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {selectedOptions.map((option) => (
                  <Chip
                    key={option.const}
                    label={option.title || `User ${option.const}`}
                    size="small"
                    variant="outlined"
                    sx={{
                      color: grey[800],
                      bgcolor: 'grey.100',
                      fontWeight: 500,
                      borderColor: 'grey.300',
                      cursor: 'default'
                    }}
                  />
                ))}
              </Box>
            ) : null
          }}
          value={selectedOptions.length === 0 ? "Unassigned" : ""}
        />
      </Box>
    );
  };

  const assignUsersTester = rankWith(
    6,
    (uischema) => uischema.scope === '#/properties/assigned_to' || uischema.options?.renderer === 'AssignUsers'
  );

  const ButtonRenderer = ({ uischema }) => {
    const { label, options } = uischema;
    if (options?.onClickAction === 'downloadZip') {
      if (!job_detail?.comp_file_list || job_detail.comp_file_list.length <= 1) {
        return null;
      }
    }

    return (
      <Button
        sx={{ background: '#ff6100', textTransform: 'none' }}
        onClick={() =>
          handleZipDownload(job_id, job_detail.comp_file_list)
        }
      >
        {label}
      </Button>
    );
  };

  /* ===== NEW RENDERER FOR BORDERED CHECKBOX (Read-Only) ===== */
  const BorderedBooleanRenderer = ({ data, uischema }) => {
    const { label } = uischema;
    const value = data || false;

    return (
      <Box
        sx={{
          border: '1px solid rgba(0, 0, 0, 0.23)',
          borderRadius: '4px',
          padding: '8.5px 14px',
          display: 'flex',
          alignItems: 'center',
          mb: 2.5,
          bgcolor: 'white' // Read-only background
        }}
      >
        <input
          type="checkbox"
          checked={value}
          disabled
          style={{ width: '18px', height: '18px', marginRight: '10px', accentColor: '#ff6100', cursor: 'default' }}
        />
        <Typography sx={{ flexGrow: 1, color: 'text.secondary', fontSize: '1rem' }}>
          {label}
        </Typography>
      </Box>
    );
  };

  const borderedBooleanTester = rankWith(3, and(uiTypeIs('Control'), optionIs('renderer', 'BorderedBoolean')));

  const RichTextReadOnlyRenderer = ({ data, uischema }) => {
    const customSx = uischema.options?.muiGrid?.sx || {};
    const label = uischema.label || uischema.text || "Instructions";

    const ctx = useJsonForms();
    const customerList = useSelector(state => state.customer.customer_list);
    const customerId = ctx?.core?.data?.customer_id;
    const selectedCustomer = customerList?.find(c => c.id === customerId);
    const specialInstructions = selectedCustomer?.special_instructions;

    return (
      <Box sx={{ mb: 2.5, ...customSx }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', mb: 0.5, display: 'block' }}>
          {label}
        </Typography>
        <Box
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: '4px',
            padding: '8.5px 14px',
            minHeight: '40px',
            bgcolor: 'white',
            whiteSpace: 'pre-line',
            '& p': { m: 0 },
            '& ul, & ol': { pl: 2, m: 0 }
          }}
          dangerouslySetInnerHTML={{ __html: data || "" }}
        />
        {specialInstructions && (
          <TextField
            label="Customer Special Instructions"
            value={specialInstructions}
            multiline
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              readOnly: true,
            }}
            sx={{ mt: 2.5 }}
          />
        )}
      </Box>
    );
  };

  const richTextTester = rankWith(5, optionIs('renderer', 'RichText'));
  const instructionsTester = rankWith(5, (uischema) => uischema.scope === '#/properties/instructions');
  const instructionsLabelTester = rankWith(5, (uischema) => uischema.scope === '#/properties/Instructions');
  const instructionSingularTester = rankWith(5, (uischema) => uischema.scope === '#/properties/instruction');

  /* ===== CUSTOM RENDERER FOR CUSTOMER (Read-Only) ===== */
  const CustomerReadOnlyRenderer = ({ data, uischema, label }) => {
    const customerList = useSelector(state => state.customer.customer_list);
    const ctx = useJsonForms();
    const rawData = ctx?.core?.data || {};
    const customerId = data !== undefined && data !== null ? data : rawData.customer_id;
    const fallbackCode = rawData._customer_display || rawData.customer_code || rawData.customer;

    const found = (customerList || []).find(c => c && (c.id === customerId || c.code === customerId));
    let displayVal = "";
    if (found) {
      displayVal = found.code || found.employee_code || String(found.id);
    } else if (fallbackCode) {
      displayVal = String(fallbackCode);
    } else if (customerId) {
      displayVal = String(customerId);
    }

    return (
      <TextField
        label={label || uischema.label || "Customer"}
        value={displayVal}
        fullWidth
        size="small"
        InputProps={{
          readOnly: true,
          sx: { color: grey[700] }
        }}
        sx={{ mb: 2.5 }}
      />
    );
  };
  const customerTester = rankWith(
    6,
    (uischema) => uischema.scope === '#/properties/customer_id' || uischema.options?.renderer === 'Customer'
  );

  /* ===== NEW RENDERER FOR JOB TYPE (Read-Only) ===== */
  const JobTypeRenderer = ({ data, uischema, schema }) => {
    const value = data || "";
    const label = uischema.label || "Job / Service Type";
    // Ensure the current value is in the options list so it displays properly
    let options = schema.enum ? [...schema.enum] : [];
    if (value && !options.includes(value)) {
      options.push(value);
    }

    return (
      <Autocomplete
        options={options}
        value={value}
        readOnly
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              ...params.InputProps,
              readOnly: true,
              sx: { color: grey[700] },
            }}
            sx={{ mb: 2.5 }}
          />
        )}
      />
    );
  };
  const jobTypeTester = rankWith(5, (uischema) => uischema.scope === '#/properties/job_type');

  /* ===== NEW RENDERER FOR TIME REQUIRED (Read-Only) ===== */
  const TimeRequiredRenderer = ({ data, uischema }) => {
    const value = data || "";
    const label = uischema.label || "Time required to do job";

    return (
      <TextField
        label={label}
        value={value}
        fullWidth
        variant="outlined"
        size="small"
        InputProps={{
          readOnly: true,
          sx: { color: grey[700] },
          label: label
        }}
        sx={{ mb: 2.5 }}
      />
    );
  };

  /* ===== NEW RENDERER FOR DESCRIPTION FIELD (Read-Only) ===== */
  const DescriptionRenderer = ({ data, uischema }) => {
    const value = data || "";
    const baseLabel = uischema.label || "Description";
    // Manually append asterisk to ensure visibility
    const label = baseLabel.includes('*') ? baseLabel : `${baseLabel} *`;

    return (
      <TextField
        label={label}
        placeholder={baseLabel}
        value={value}
        multiline
        fullWidth
        variant="outlined"
        size="small"
        InputProps={{
          readOnly: true,
          sx: { color: grey[700] },
          label: label // Explicitly pass label for notch
        }}
        sx={{
          mb: 2.5,
          '& .MuiOutlinedInput-root': {
            minHeight: '107px',
            alignItems: 'flex-start',
            backgroundColor: 'white'
          }
        }}
      />
    );
  };

  /* ===== CUSTOM LAYOUT RENDERERS TO INJECT SPACING ===== */
  const CustomHorizontalLayoutRenderer = withJsonFormsLayoutProps((props) => {
    const { uischema, renderers, cells, schema, path, enabled, visible } = props;
    if (visible === false) return null;

    return (
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2.5}>
          {uischema.elements.map((element, index) => (
            <Grid
              item
              xs={12}
              sm={element.options?.xs || (12 / uischema.elements.length)}
              key={index}
              sx={element.options?.muiGrid?.sx || {}}
            >
              <JsonFormsDispatch
                schema={schema}
                uischema={element}
                path={path}
                enabled={enabled}
                renderers={renderers}
                cells={cells}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  });

  const CustomVerticalLayoutRenderer = withJsonFormsLayoutProps((props) => {
    const { uischema, renderers, cells, schema, path, enabled, visible } = props;
    if (visible === false) return null;

    return (
      <Box sx={{ width: '100%' }}>
        <Grid container direction="column" spacing={2}>
          {uischema.elements.map((element, index) => (
            <Grid item xs={12} key={index}>
              <JsonFormsDispatch
                schema={schema}
                uischema={element}
                path={path}
                enabled={enabled}
                renderers={renderers}
                cells={cells}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  });

  // Rank higher than standard control for description scope
  const descriptionTester = rankWith(4, (uischema) => {
    return uischema.scope === '#/properties/description';
  });

  const fileNameTester = rankWith(5, (uischema) => {
    if (!uischema.scope) return false;
    const scope = uischema.scope;
    return (
      scope.endsWith('submitted_file_list') ||
      scope.endsWith('completed_file_list') ||
      scope.endsWith('submitted_file') ||
      scope.endsWith('completed_file')
    );
  });

  const renderers = [
    { tester: rankWith(3, uiTypeIs('VerticalLayout')), renderer: CustomVerticalLayoutRenderer },
    ...materialRenderers,
    {
      tester: rankWith(5, (uischema) => uischema.options?.renderer === 'TimeRequired' || uischema.scope?.includes('time_required_to_do_job')),
      renderer: withJsonFormsControlProps(TimeRequiredRenderer)
    },
    {
      tester: fileInputTester,
      renderer: props => (
        <FileWidget
          {...props}
          mode={mode}
          proof_log_data={proof_log_data}
          showBrandOption={false}
          showLibraryLink={true}
          job_id={job_id}
        />
      )
    },
    {
      tester: fileInputWithBrandTester,
      renderer: props => (
        <FileWidget
          {...props}
          mode={mode}
          proof_log_data={proof_log_data}
          showBrandOption={true}
          showLibraryLink={false}
          job_id={job_id}
        />
      )
    },
    { tester: rankWith(3, uiTypeIs('Button')), renderer: ButtonRenderer },
    { tester: assignUsersTester, renderer: withJsonFormsControlProps(AssignUsersRenderer) },
    {
      tester: rankWith(6, (uischema) => uischema.scope === '#/properties/submitted_date' || uischema.type === 'Submitted Date Label' || uischema.options?.renderer === 'SubmittedDateLabel'),
      renderer: withJsonFormsControlProps(SubmittedDateLabelRenderer)
    },
    {
      tester: rankWith(6, (uischema) => uischema.scope === '#/properties/completed_date' || uischema.scope === '#/properties/completed_file_date' || uischema.type === 'Completed Date Label' || uischema.options?.renderer === 'CompletedDateLabel'),
      renderer: withJsonFormsControlProps(CompletedDateLabelRenderer)
    },
    { tester: borderedBooleanTester, renderer: withJsonFormsControlProps(BorderedBooleanRenderer) },
    { tester: descriptionTester, renderer: withJsonFormsControlProps(DescriptionRenderer) },
    {
      tester: fileNameTester,
      renderer: props => {
        const isCompleted = props.uischema.scope && props.uischema.scope.includes('completed');
        return (
          <FileWidget
            {...props}
            mode={mode}
            proof_log_data={proof_log_data}
            showBrandOption={isCompleted}
            showLibraryLink={false}
            job_id={job_id}
            compact={props.path?.includes('job_items')}
            enabled={false} // Read-only mode for details view
          />
        );
      }
    },
    { tester: richTextTester, renderer: withJsonFormsControlProps(RichTextReadOnlyRenderer) },
    { tester: instructionsTester, renderer: withJsonFormsControlProps(RichTextReadOnlyRenderer) },
    { tester: instructionsLabelTester, renderer: withJsonFormsControlProps(RichTextReadOnlyRenderer) },
    { tester: instructionSingularTester, renderer: withJsonFormsControlProps(RichTextReadOnlyRenderer) },
    { tester: customerTester, renderer: withJsonFormsControlProps(CustomerReadOnlyRenderer) },
    { tester: jobTypeTester, renderer: withJsonFormsControlProps(JobTypeRenderer) }
  ];

  const dynamicSchema = useMemo(() => {
    if (!job_form?.job_schema) return null;
    const schemaCopy = JSON.parse(JSON.stringify(job_form.job_schema));

    // Ensure properties object exists
    if (!schemaCopy.properties) {
      schemaCopy.properties = {};
    }

    // Update enum for 'stage' property to match database reality
    if (schemaCopy.properties.stage) {
      if (company_process_stage?.length) {
        schemaCopy.properties.stage.enum = company_process_stage.map(s => s.name);
      } else if (sidebar_menus && sidebar_menus.length > 0) {
        // Fallback to sidebar stages if company_process_stage is missing
        schemaCopy.properties.stage.enum = sidebar_menus.flatMap(menu => (menu.stages || []).map(s => s.name));
      }
    }

    // PATCH: Ensure essential fields exist in schema to avoid "No renderer found" or missing field errors
    const ensureProperty = (propName, type = 'string', title = undefined) => {
      if (!schemaCopy.properties[propName]) {
        schemaCopy.properties[propName] = { type, title };
      }
    };

    ensureProperty('stage', 'string', 'Stage');
    ensureProperty('job_type', 'string', 'Job / Service Type');
    ensureProperty('instructions', 'string', 'Instructions');
    ensureProperty('instruction', 'string', 'Instruction');
    ensureProperty('job_items', 'array', 'Job Items');
    ensureProperty('description', 'string', 'Description');
    ensureProperty('ref_No', 'string', 'Reference #');
    ensureProperty('priority', 'string', 'Priority');
    ensureProperty('time_required_to_do_job', 'string', 'Time required to do job');

    // Add Customer dropdown (read-only in detail mode)
    const customerOptions = (customer_list || [])
      .filter(c => c && (c.id || c.code))
      .map(c => ({
        const: c.id,
        title: String(c.code || c.employee_code || `ID: ${c.id}`)
      }));

    if (formData?.customer_id && !customerOptions.some(opt => opt.const === formData.customer_id)) {
      const fallbackTitle = formData._customer_display || formData.customer_code || formData.customer;
      if (fallbackTitle) {
        customerOptions.unshift({
          const: formData.customer_id,
          title: String(fallbackTitle)
        });
      }
    }

    if (customerOptions.length > 0) {
      schemaCopy.properties.customer_id = {
        type: "integer",
        title: "Customer",
        oneOf: customerOptions
      };
    } else if (formData?.customer_id && (formData._customer_display || formData.customer_code)) {
      schemaCopy.properties.customer_id = {
        type: "integer",
        title: "Customer",
        oneOf: [{
          const: formData.customer_id,
          title: String(formData._customer_display || formData.customer_code)
        }]
      };
    } else {
      ensureProperty('customer_id', 'integer', 'Customer');
    }

    // Add Assign Users dropdown / multi-chip
    const effectiveUsers = (company_users && company_users.length > 0) ? company_users : (company_users_list || []);
    if (effectiveUsers && effectiveUsers.length > 0) {
      const assignedOptions = (effectiveUsers || [])
        .filter(u => u && u.id && (u.is_active || (Array.isArray(formData?.assigned_to) ? formData.assigned_to.includes(u.id) : u.id === formData?.assigned_to)))
        .filter(u => u.role === 'ADDNECTAR_ARTIST' || u.role === 6 || (Array.isArray(formData?.assigned_to) ? formData.assigned_to.includes(u.id) : u.id === formData?.assigned_to))
        .map(u => {
          const rawName = String((`${u.first_name || ""} ${u.last_name || ""}`).trim() || u.email || `User ${u.id}`);
          const count = userJobCounts[u.id];
          const title = count !== undefined ? `${rawName} (${count})` : rawName;
          return {
            const: u.id,
            title: title
          };
        });

      // Add currently assigned user as fallback if they are missing from the list
      const currentAssignedIds = Array.isArray(formData?.assigned_to) ? formData.assigned_to : (formData?.assigned_to ? [formData.assigned_to] : []);
      currentAssignedIds.forEach(id => {
        if (!assignedOptions.some(opt => opt.const === id)) {
          assignedOptions.push({
            const: id,
            title: `Assigned User ID: ${id}`
          });
        }
      });

      schemaCopy.properties.assigned_to = {
        type: ["array", "integer"],
        title: "Assign Users",
        items: {
          type: "integer",
          oneOf: assignedOptions
        },
        oneOf: assignedOptions
      };
    } else {
      ensureProperty('assigned_to', 'array', 'Assign Users');
    }

    return schemaCopy;
  }, [job_form, company_process_stage, sidebar_menus, customer_list, company_users, company_users_list, userJobCounts]);

  const dynamicUiSchema = useMemo(() => {
    if (!job_form?.job_ui_update_schema) return null;
    const uiSchemaCopy = JSON.parse(JSON.stringify(job_form.job_ui_update_schema));

    const applyThreeColumnLayout = (ui) => {
      if (!ui || !ui.elements) return;

      const oldElements = [...ui.elements];
      ui.elements = [];

      const collectedStandard = [];
      const collectedFiles = [];

      const flushStandard = () => {
        while (collectedStandard.length > 0) {
          const row = collectedStandard.splice(0, 3);
          ui.elements.push({
            type: "HorizontalLayout",
            options: { spacing: 2 },
            elements: row
          });
        }
      };

      const flushFiles = () => {
        while (collectedFiles.length > 0) {
          const row = collectedFiles.splice(0, 2);
          ui.elements.push({
            type: "HorizontalLayout",
            options: { spacing: 2 },
            elements: row
          });
        }
      };

      const processElements = (elements) => {
        elements.forEach(el => {
          if (el.type === 'Control') {
            if (el.scope === '#/properties/instructions') {
              flushStandard();
              flushFiles();
              ui.elements.push({ ...el, options: { ...el.options, xs: 12 } });
            } else if (el.scope?.includes('file')) {
              flushStandard();
              collectedFiles.push({ ...el, options: { ...el.options, xs: 6 } });
            } else if (el.scope?.includes('job_items')) {
              flushStandard();
              flushFiles();
              ui.elements.push(el);
            } else {
              flushFiles();
              collectedStandard.push({ ...el, options: { ...el.options, xs: 4 } });
            }
          } else if (el.type === 'HorizontalLayout' || el.type === 'VerticalLayout') {
            if (el.elements) processElements(el.elements);
          } else {
            flushStandard();
            flushFiles();
            ui.elements.push(el);
          }
        });
      };

      processElements(oldElements);
      flushStandard();
      flushFiles();
    };

    const hasField = (elements, field) => {
      if (!elements) return false;
      return elements.some(el => {
        if (el.scope === `#/properties/${field}`) return true;
        if (el.elements) return hasField(el.elements, field);
        if (el.options?.detail?.elements) return hasField(el.options.detail.elements, field);
        return false;
      });
    };

    if (!hasField(uiSchemaCopy.elements, 'customer_id') || !hasField(uiSchemaCopy.elements, 'assigned_to')) {
      const topFields = [];
      if (!hasField(uiSchemaCopy.elements, 'customer_id')) {
        topFields.push({ type: "Control", scope: "#/properties/customer_id", label: "Customer" });
      }
      if (!hasField(uiSchemaCopy.elements, 'assigned_to')) {
        topFields.push({ type: "Control", scope: "#/properties/assigned_to", label: "Assign Users" });
      }

      if (topFields.length > 0) {
        uiSchemaCopy.elements.unshift({
          type: "HorizontalLayout",
          elements: topFields
        });
      }
    }

    applyThreeColumnLayout(uiSchemaCopy);

    return uiSchemaCopy;
  }, [job_form]);

  const statusList = [
    "New",
    "In Progress",
    "Completed",
    "Hold",
    "Approval Requested",
    "Approved",
    "Rejected",
    "Quote Requested",
    // "Quote Approval Needed",
    "Archived",
  ];
  const auth = isAuth();
  const currentUserRole = Number(auth?.role);

  return (
    <Box
      className="jobWrapper"
      sx={{
        flex: 1,
        mr: 1,

      }}
    >
      <Box sx={{ width: '100%' }}>
        <Box
          sx={{
            bgcolor: '#fff',
            px: 2,
            py: 1.5,
            color: '#000',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px'
          }}
        >
          <Typography
            sx={{
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '15px'
            }}
            onClick={() => navigate('/')}
          >
            Job
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>


            {currentUserRole === 7 && (
              <Button
                variant="text"
                startIcon={<AddBoxOutlinedIcon />}
                sx={{
                  color: "#fff",
                  textTransform: "none",
                  backgroundColor: "#ff6100",
                }}
                onClick={() => {
                  dispatch(clearJobData());
                  const url = selected_process_tab
                    ? `/create-job?process_id=${selected_process_tab}`
                    : "/create-job";
                  navigate(url);
                }}
              >
                Create New Job
              </Button>
            )}

            {(() => {
              const stageName = (job_detail?.stage?.name || "").trim().toLowerCase();
              const isCompleted = stageName === "completed";

              const process = company_process?.find(p => String(p.id) === String(job_detail?.process_id));
              const processAllows = !!(process?.standard_proof || process?.annotated_proof);


              if (!(isCompleted && processAllows)) return null;

              return (
                <Button
                  variant="contained"
                  sx={{ color: "#fff", textTransform: "none", backgroundColor: "#ff6100" }}
                  endIcon={<SendIcon />}
                  onClick={() => {
                    dispatch(setJobData(job_detail.job_data));
                    setOpenSendProof(true);
                  }}
                >
                  Send Proof
                </Button>
              );
            })()}

          </Box>
        </Box>
        <Box
          sx={{
            bgcolor: '#fff',
            px: 2,
            py: 1.5,
            mt: 2,
            color: '#000',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            borderBottom: '17px solid #FFF5F2'
          }}
        >
          <Typography
            sx={{
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '15px'
            }}
            onClick={() => navigate('/')}
          >
            Job # {job_id}
          </Typography>

          {/* CENTER - STATUS CHIPS */}
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: "flex-start",
              flex: 1,
              mx: 2,
            }}
          >
            {(() => {
              let orderedStages = [];
              if (sidebar_menus && sidebar_menus.length > 0) {
                // Flatten the stages from sidebar menus to match sidebar order
                orderedStages = sidebar_menus.flatMap(menu => menu.stages || []);
              } else if (company_process_stage && company_process_stage.length > 0) {
                orderedStages = company_process_stage;
              } else {
                orderedStages = statusList;
              }

              return orderedStages.map((statusItem) => {
                // Handle both object (from db) and string (fallback)
                const statusName = typeof statusItem === 'string' ? statusItem : statusItem.name;
                const currentStageName = job_detail?.stage?.name;

                // Check if this status is the current one
                const isActive = currentStageName && statusName?.toLowerCase() === currentStageName?.toLowerCase();

                return (
                  <Chip
                    key={statusName}
                    label={statusName}
                    size="small"
                    sx={{
                      fontSize: "12px",
                      borderRadius: "10px",
                      bgcolor: isActive ? "#fff3e8" : "white",
                      color: isActive ? "#ff6100" : "#9e9e9e",
                      border: isActive ? "1px solid #ff6100" : "1px solid #e0e0e0",
                      fontWeight: isActive ? 600 : 400
                    }}
                  />
                );
              });
            })()}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
            <Button
              variant="text"
              onClick={() => {
                const url = selected_process_tab ? `/update-job/${job_id}?process_id=${selected_process_tab}` : `/update-job/${job_id}`;
                navigate(url);
              }}
              sx={{
                minWidth: 'auto', // removes extra button width
                padding: 0,
              }}
            >
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 30,
                height: 30,
                backgroundColor: '#ff6100',
                borderRadius: '4px',
                color: '#fff'
              }}>
                <EditSvgIcon sx={{ fontSize: 18 }} />
              </Box>
            </Button>
          </Box>
        </Box>

        <Box sx={{ px: 2, py: 2, bgcolor: 'white', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
          <ThemeProvider theme={theme}>
            <Box
              sx={{
                width: '100%'
              }}
            >
              {(!formData || !dynamicSchema || !dynamicUiSchema || !listsReady) && (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}>
                  <CircularProgress sx={{ color: '#ff6100' }} />
                </Box>
              )}
              {formData && dynamicSchema && dynamicUiSchema && listsReady && (
                <JsonForms
                  schema={dynamicSchema}
                  uischema={dynamicUiSchema}
                  data={formData}
                  renderers={renderers}
                  cells={materialCells}
                  readonly
                  validationMode="NoValidation"
                />
              )}
              {formData?.logo_references?.length > 0 && (
                <Box sx={{ mt: 3, p: 2, bgcolor: '#fff', border: '1px solid #e0e0e0', borderRadius: 1 }}>
                  <Typography sx={{ fontWeight: 600, mb: 2 }}>Logo References</Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    {formData.logo_references.map((logo, index) => {
                      const path = logo.file_path || logo;
                      const cleanPath = path.startsWith('/') ? path.slice(1) : path;
                      const url = path.startsWith('http')
                        ? path
                        : `https://sewrobj.us-east-1.linodeobjects.com/${cleanPath}`;
                      const isImage = /\.(jpg|jpeg|png|gif|webp)($|\?)/i.test(url);
                      const isPdf = /\.pdf($|\?)/i.test(url);

                      return (
                        <Box
                          key={index}
                          sx={{
                            width: 100,
                            height: 100,
                            border: '1px solid #eee',
                            borderRadius: 1,
                            bgcolor: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer'
                          }}
                        >
                          {isImage ? (
                            <img
                              src={url}
                              alt="logo"
                              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              onClick={() => window.open(url, '_blank')}
                            />
                          ) : isPdf ? (
                            <PdfThumbnail
                              url={url}
                              width={100}
                              onClick={() => {
                                // Create a temporary link to download the PDF
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = path.split('/').pop() || 'document.pdf';
                                link.target = '_blank';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                            />
                          ) : (
                            <Typography
                              variant="caption"
                              onClick={() => window.open(url, '_blank')}
                            >
                              FILE
                            </Typography>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 5 }}>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    dispatch(clearJobData());
                    navigate('/');
                  }}
                  sx={{ mr: 2 }}
                >
                  Cancel
                </Button>

              </Box>

            </Box>
          </ThemeProvider>
        </Box>

        <SendProofModal
          job_id={job_id}
          job_detail={job_detail}
          comp_file_list={job_detail?.comp_file_list || []}
          is_SendProof_modal_open={openSendProof}
          handleSendProofModal={setOpenSendProof}
        />

      </Box>
    </Box>
  );
};

export default JobDetail;